export interface IOpinionLineChartEventTypeStyle {
  text: string;
  textColor: string;
  backgroundColor: string;
}

/** 情报 Opinion 折线图 / 事件气泡：事件类型标签颜色配置（仅 intelligence 模块维护） */
export const OPINION_LINE_CHART_EVENT_TYPE_STYLES: IOpinionLineChartEventTypeStyle[] =
  [
    {
      text: 'Holiday',
      textColor: '#5086F3',
      backgroundColor: '#5086F31F',
    },
    {
      text: 'season_pass',
      textColor: '#77E097',
      backgroundColor: '#77E09729',
    },
    {
      text: 'In-game Events',
      textColor: '#E8C947',
      backgroundColor: '#E8C94729',
    },
    {
      text: 'crisis',
      textColor: '#7F6FF1',
      backgroundColor: '#7F6FF11F',
    },
    {
      text: 'Promo',
      textColor: '#5EC8F1',
      backgroundColor: '#5EC8F11F',
    },
    {
      text: 'monetization',
      textColor: '#AD53D4',
      backgroundColor: '#AD53D41F',
    },
    {
      text: 'version_release',
      textColor: '#F19E55',
      backgroundColor: '#F19E5524',
    },
    {
      text: 'esports',
      textColor: '#488E89',
      backgroundColor: '#488E891F',
    },
    {
      text: 'marketing_campaign',
      textColor: '#F17C86',
      backgroundColor: '#F17C861F',
    },
    {
      text: 'community',
      textColor: '#2648A6',
      backgroundColor: '#2648A61F',
    },
    {
      text: 'maintenance',
      textColor: '#358561',
      backgroundColor: '#3585611F',
    },
    {
      text: 'beta_test',
      textColor: '#A8831D',
      backgroundColor: '#A8831D1F',
    },
    {
      text: 'Others',
      textColor: '#6E7794',
      backgroundColor: '#6E77941F',
    },
    {
      text: 'observance',
      textColor: '#413CA6',
      backgroundColor: '#413CA61F',
    },
    {
      text: 'Anniversary',
      textColor: '#307DA6',
      backgroundColor: '#307DA61F',
    },
    {
      text: 'bank',
      textColor: '#642787',
      backgroundColor: '#6427871F',
    },
    {
      text: 'unknown',
      textColor: '#A65B29',
      backgroundColor: '#A65B291F',
    },
    {
      text: 'ingame_event',
      textColor: '#A64453',
      backgroundColor: '#A644531F',
    },
    {
      text: 'Player Discussions',
      textColor: '#245552',
      backgroundColor: '#2455521F',
    },
    {
      text: 'Marketing Events',
      textColor: '#2E3247',
      backgroundColor: '#2E32471F',
    },
    {
      text: 'holiday',
      textColor: '#3965CC',
      backgroundColor: '#A6C9FF29',
    },
    {
      text: 'Announcement',
      textColor: '#4DAB7D',
      backgroundColor: '#C0EBD229',
    },
    {
      text: 'Game Show',
      textColor: '#CFA92D',
      backgroundColor: '#FFF1964D',
    },
    {
      text: 'Version',
      textColor: '#5E54CC',
      backgroundColor: '#D2C8FD29',
    },
    {
      text: 'regional',
      textColor: '#45A1CC',
      backgroundColor: '#B5EFFF29',
    },
    {
      text: 'collab',
      textColor: '#873BAD',
      backgroundColor: '#DFB2ED29',
    },
    {
      text: 'public',
      textColor: '#CC7B3D',
      backgroundColor: '#FFD8AB33',
    },
    {
      text: 'others',
      textColor: '#4C526E',
      backgroundColor: '#B8BED11F',
    },
  ];

function normalizeEventTypeToken(value: string): string {
  return value.trim().toLowerCase().replace(/[\s-]+/g, '_');
}

const STYLE_KEY_SET = new Set(
  OPINION_LINE_CHART_EVENT_TYPE_STYLES.map(item => item.text),
);

/** 兼容历史 API event_type / event_type_code → 配置 key */
const EVENT_TYPE_STYLE_ALIAS_MAP: Record<string, string> = {
  'Season pass': 'season_pass',
  'In-game event': 'In-game Events',
  Crisis: 'crisis',
  Promotion: 'Promo',
  'IP collaboration': 'collab',
  'Version release': 'version_release',
  Esports: 'esports',
  'Marketing campaign': 'marketing_campaign',
  'Community ops': 'community',
  Maintenance: 'maintenance',
  'Beta test': 'beta_test',
  Season: 'season_pass',
  season: 'season_pass',
  promotion: 'Promo',
  promo: 'Promo',
  ingame: 'In-game Events',
  in_game: 'In-game Events',
  ingame_events: 'In-game Events',
  version: 'Version',
  marketing: 'marketing_campaign',
  ip_collaboration: 'collab',
  ip_collab: 'collab',
  community_ops: 'community',
  beta: 'beta_test',
  game_show: 'Game Show',
  player_discussions: 'Player Discussions',
  marketing_events: 'Marketing Events',
  other: 'Others',
};

const DEFAULT_EVENT_TYPE_STYLE =
  OPINION_LINE_CHART_EVENT_TYPE_STYLES.find(item => item.text === 'Others')!;

export function resolveOpinionLineChartEventTypeKey(
  eventType?: string,
): string {
  const raw = (eventType || '').trim();
  if (!raw) {
    return 'Others';
  }

  if (STYLE_KEY_SET.has(raw)) {
    return raw;
  }

  const aliasKey =
    EVENT_TYPE_STYLE_ALIAS_MAP[raw] ||
    EVENT_TYPE_STYLE_ALIAS_MAP[normalizeEventTypeToken(raw)];
  if (aliasKey && STYLE_KEY_SET.has(aliasKey)) {
    return aliasKey;
  }

  return 'Others';
}

export function getOpinionLineChartEventTypeStyle(
  eventType?: string,
): IOpinionLineChartEventTypeStyle {
  const key = resolveOpinionLineChartEventTypeKey(eventType);
  return (
    OPINION_LINE_CHART_EVENT_TYPE_STYLES.find(item => item.text === key) ||
    DEFAULT_EVENT_TYPE_STYLE
  );
}
